import React, { useState, useEffect } from 'react';
import alanBtn from '@alan-ai/alan-sdk-web';
import { Typography } from '@material-ui/core';

import wordsToNumbers from 'words-to-numbers';

import NewsCards from './components/NewsCards/NewsCards';
import useStyles from './styles';


const alanKey = '97df2aafa841bb44a03da0e074215eef2e956eca572e1d8b807a3e2338fdd0dc/stage';

const App = () => {
    const [newsArticles, setNewsArticles] = useState([]);
    const [activeArticle, setActiveArticle] = useState(-1);
    
    const classes = useStyles();

    useEffect(() => {
        alanBtn({
            key: alanKey,
            onCommand: ({ command, articles, number }) => {
                if(command === 'newHeadlines') {
                    setNewsArticles(articles);
                    setActiveArticle(-1);
                } else if (command === 'highlight') {
                    setActiveArticle ((prevActiveArticle) => prevActiveArticle + 1);
                } else if(command === 'open') {
                    const parsedNumber = number.length > 2 ? wordsToNumbers((number), { fuzzy: true }) : number;
                    const article = articles[parsedNumber - 1];
          
                    if (parsedNumber > articles.length) {
                      alanBtn().playText('Please try that again...');
                    } else if (article) {
                      window.open(article.url, '_blank');
                      alanBtn().playText('Opening...');
                    } else {
                      alanBtn().playText('Please try that again...');
                    }
                  }
                },
              });
            }, []);

            return (
              <div>
                <div className={classes.logoContainer}>
                <img src="./images/logo.png" className={classes.newsAppLogo} alt=" News App " />
            </div>
            <NewsCards articles={newsArticles} activeArticle={activeArticle} />
                
                  <div className={classes.footer}>
                    <Typography variant="body1" component="h2">
                    <br>
                      </br>
                      <br>
                      </br>
                      <br>
                      </br>
                      <br>
                      </br>
                      Copyright &copy; {new Date().getFullYear()} <a className={classes.link} href="https://nawaf.tech">Nawaf.Tech</a> .All rights reserved
                    </Typography>
                  </div>
                
              </div>
            );
          };

export default App;